export default function feature(state) {
  return state.feature
}



// WEBPACK FOOTER //
// ./src/config-builders/project/reducers/feature.js